
import { clone, parseFloatString, round2dec, twoDecimals } from "../../../shared/utility";
import { calculateBrokerCommission } from "./BrokersLogic";

export const commissionDistributionPDF = props => {
    const { 
        name, 
        hasLessorAssociate,
        hasLesseeAssociate,
        data
    } = props;

    if (name === 'lessor') {
        const renderCommissionsLessor = () => {
            let tot = 0;
            if (data.commission_splits_agent) {
                data.commission_splits_agent.forEach(csa => {
                    tot += parseFloatString(csa.Percentage)
                })
            }
    
            return `<tbody>
                    <tr>
                        <td class="col-40">
                            <strong>Name</strong>
                        </td>
                        <td class="col-60">
                            <strong>Percentage</strong>
                        </td>
                    </tr>
                    ${data.commission_splits_agent.map((c, i) => {
                        return `<tr>
                                <td class="col-40">${c.Name}</td>
                                <td class="col-60">${twoDecimals(parseFloatString(c.Percentage))} %</td>
                            </tr>`
                    }).join('')}
                    <tr>
                        <td class="col-40">
                            <strong>Total</strong>
                        </td>
                        <td class="col-60">${twoDecimals(tot)} %</td>
                    </tr>
                </tbody>`;
        };
        
        const renderCommissionsOtherLessor = () => {
            return `<tbody>
                    <tr>
                        <td class="col-40">
                            <strong>Name</strong>
                        </td>
                        <td class="col-30">
                            <strong>Percentage</strong>
                        </td>
                        <td class="col-30">
                            <strong>Commission Value</strong>
                        </td>
                    </tr>
                    <tr>
                        <td class="col-40">Lessor Referral</td>
                        <td class="col-30"></td>
                        <td class="col-30">
                            ${data.referral_firm_fee_amount_choice === "Value"
                                ? data.referral_firm_fee_amount
                                : data.referral_firm_fee_amount_percentage + " %"}
                        </td>
                    </tr>
                    <tr>
                        <td class="col-40">Lessor - Outside Broker(s)</td>
                        <td class="col-30"></td>
                        <td class="col-30">${calculateBrokerCommission('lessor_outside_broker', data)}</td>
                    </tr>
                </tbody>`;
        };
    
        return `<div>
                <h4 style="text-decoration:underline">COMMISSION DISTRIBUTION ${name.toUpperCase()}</h4>
            </div>
            ${hasLessorAssociate ? `<div class="the-table">
                <table>${renderCommissionsLessor()}</table>
            </div>` : ``}
            <div class="the-table mt-10" style="display:none">
                <table>${renderCommissionsOtherLessor()}</table>
            </div>`
    }

    if (name === 'lessee') {
        const renderCommissionsLessee = () => {
            let tot = 0;
            if (data.commission_splits_agent2) {
                data.commission_splits_agent2.forEach(csa => {
                    tot += parseFloatString(csa.Percentage)
                })
            }
    
            return `<tbody>
                    <tr>
                        <td class="col-40">
                            <strong>Name</strong>
                        </td>
                        <td class="col-60">
                            <strong>Percentage</strong>
                        </td>
                    </tr>
                    ${data.commission_splits_agent2.map((c, i) => {
                        return (
                            <tr key={`${i}-agent`}>
                                <td class="col-40">{c.Name}</td>
                                <td class="col-60">{twoDecimals(parseFloatString(c.Percentage))} %</td>
                            </tr>
                        );
                    }).join('')}
                    <tr>
                        <td class="col-40">
                            <strong>Total</strong>
                        </td>
                        <td class="col-60">${twoDecimals(tot)} %</td>
                    </tr>
                </tbody>`;
        };
        
        const renderCommissionsOtherLessee = () => {
            return `<tbody>
                    <tr>
                        <td class="col-40">
                            <strong>Name</strong>
                        </td>
                        <td class="col-60">
                            <strong>Value</strong>
                        </td>
                    </tr>
                    <tr>
                        <td class="col-40">Lessee Referral</td>
                        <td class="col-60">
                            ${data.lessee_referral_firm_fee_amount_choice === "Value"
                                ? data.lessee_referral_firm_fee_amount
                                : data.lessee_referral_firm_fee_amount_percentage + " %"}
                        </td>
                    </tr>
                    <tr>
                        <td class="col-40">Lessee - Outside Broker</td>
                        <td class="col-60">${calculateBrokerCommission('outside_broker',data)}</td>
                    </tr>
                </tbody>`;
        };

        return `<div>
                <h4 style="text-decoration:underline">COMMISSION DISTRIBUTION ${name.toUpperCase()}</h4>
            </div>
            ${hasLesseeAssociate ? `<div class="the-table">
                <table>
                    ${renderCommissionsLessee()}
                </table>
            </div>` : ``}
            <div class="the-table mt-10" style="display:none">
                <table>
                    ${renderCommissionsOtherLessee()}
                </table>
            </div>`
    }

    return ``
}